import React, { useEffect, useState, useCallback } from "react";
import AlertIconSVG from "assets/svg/alert-info-icon-sm-svg";
import { useDropzone } from "react-dropzone";
import ImageDropIconSVG from "assets/svg/image-drop-icon";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import toast from "react-hot-toast";
import _, { set } from "lodash";
import { maxUploadSize } from "utils/constant";

import { useTranslation } from "react-i18next";


const DropzoneGalleryComponent = (
  {
    id = "media-upload",
    userData,
    formContainer = "form-input-container",
    linkType,
    setItems = () => { },
    setProgress = () => { },
    progress = {},
    onUploadMultiple = () => { },
    icon = null,
    buttonText = "Browse Images",
    onUpload = () => { },
    errorMessage = null,
    fileSizeError = null,
    ...props
  },
  ref
) => {
  const { t } = useTranslation();
  const [error, setError] = useState(null)
  const { http } = global.services;
  const uploadSizeModal = useDialogHook(UploadSizeModal);

  const onDrop = (async acceptedFiles => {
    let indexTracker = 0;
    let IDArray = [];
    const linkTypeLength = linkType.length;
    for(const file of acceptedFiles) {
      if (file.size > maxUploadSize) {
        showUploadSizeModalError();
        return;
      }
      const randomId = Math.random().toString(36).substring(2, 7);
      IDArray.push(randomId);
      file.progress = 100;
      file.progressId = randomId;
    }

    await onUploadMultiple([...acceptedFiles]);

    for(const file of acceptedFiles) {
      onUploadImagesVideos(file, IDArray[indexTracker], linkTypeLength + indexTracker);
      indexTracker++;
    }

  });

  // ===================== functions =========================
  const onUploadImagesVideos = async (file, progressID, index) => {
    let payload = new FormData();
    payload.append("user_profile_id", userData?.profile?.id);
    payload.append("type", "image");
    payload.append("file", file);
    payload.append("order", index);

    if (!_.isEmpty(file)) {
      try {
        const { data } = await http.post(`public/user-galleries/pre-upload`, payload, {
          headers: { "Content-Type": "multipart/form-data" },onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(prev=> {
              return {
                ...prev,
                [progressID]: percentCompleted-1
            }})
          }
        });
        setItems(prev=> {
          const prevBuffer = prev;
          prevBuffer[index].media_id = data?.media_id; 
          return prevBuffer;
        });
        setProgress(prev=> {
          return {
            ...prev,
            [progressID]: 100
        }})

        setTimeout(() => {
          setProgress(prev=> {
            return {
              ...prev,
              refresh: 100
          }})
        }, 1000);


      } catch (error) {
        toast.error(
          error?.data?.message || "It appears that something went wrong"
        );
      }
    }
  };


  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  useEffect(() => {
    if (errorMessage) {
      setError(errorMessage)
    }
  }, [errorMessage])

  return (
    <>
      <div className="relative h-14 image-dropzone flex">
            {/* dropzone */}
            <div {...getRootProps()}>
              <input ref={ref} {...getInputProps()} />
              <div className="add-photo-dropzone flex flex-wrap justify-center px-2">
                <ImageDropIconSVG />
                <p className="text-sm text-gray-500 mt-2 text-center">{t('dragDrop')} <span className="text-blue">{t('browseFiles')}</span></p>
              </div>
            </div>
      </div>
      {error && (
        <p className="input-error-message mt-2 -mb-1 flex">
          <AlertIconSVG /> {error}
        </p>
      )}
    </>
  );
};

const DropzoneUploadGallery = React.forwardRef(DropzoneGalleryComponent);

export default DropzoneUploadGallery;
